import { useRouter } from 'next/router';
import { useMemo } from 'react';
import unAuthorizedPages from './unAuthorizedPages';
export const useCheckAuthorizedPage = () => {
  const router = useRouter();

  const doesPageRequireAuth = useMemo(() => {
    return !unAuthorizedPages.includes(router.pathname);
  }, [router.pathname]);

  return { doesPageRequireAuth };
};
